import { render, staticRenderFns } from "./BaseTeaser.vue?vue&type=template&id=7b404044"
import script from "./BaseTeaser.vue?vue&type=script&lang=ts"
export * from "./BaseTeaser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports